import { render } from "./ActasJrvStreamlined.vue?vue&type=template&id=a5086aa6&scoped=true"
import script from "./ActasJrvStreamlined.vue?vue&type=script&lang=ts"
export * from "./ActasJrvStreamlined.vue?vue&type=script&lang=ts"

import "./ActasJrvStreamlined.vue?vue&type=style&index=0&id=a5086aa6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5086aa6"

export default script